import React from "react";
import yellowIndicator from "@src/assets/svg/yellow-indicator-icon.svg";
import { OTAInstallActionButton } from "@src/components/atoms/ota-install-action-button/ota-install-action-button";
import styles from "./ota-accept-and-push.module.scss";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import { useOtaAcceptAndPush } from "./use-ota-accept-and-push";

const cssClassName = "ota-accept-and-push";
interface OTAAcceptAndPushProps {
  activeInstallationData?: ActiveInstallationProcessPayload | null;
}
export default function OTAAcceptAndPush({
  activeInstallationData,
}: OTAAcceptAndPushProps) {
  const {
    texts,
    descriptionText,
    handleAcceptAndPush,
    handleCancelRequest,
    isCancelRequestLoading,
  } = useOtaAcceptAndPush({
    activeInstallationData,
  });
  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__content`]}>
        <img
          src={yellowIndicator}
          alt=""
          className={styles[`${cssClassName}__indicator`]}
        />
        <div className={styles[`${cssClassName}__text`]}>
          <span className={styles[`${cssClassName}__title`]}>
            {texts.titleHasItemName ? (
              <>
                {texts.titlePrefix}
                <span
                  className={styles[`${cssClassName}__title-item-name`]}
                  title={texts.itemName}
                >
                  {texts.itemName}
                </span>
                {texts.titleSuffix}
              </>
            ) : (
              texts.title
            )}
          </span>
          <span className={styles[`${cssClassName}__description`]}>
            {descriptionText}
          </span>
        </div>
      </div>

      <div className={styles[`${cssClassName}__actions`]}>
        <OTAInstallActionButton
          text={texts.cancelRequestButtonText}
          variant="secondary"
          fun={handleCancelRequest}
          disabled={isCancelRequestLoading}
        />
        <OTAInstallActionButton
          text={texts.acceptAndPushButtonText}
          variant="primary"
          fun={handleAcceptAndPush}
          tooltip={
            activeInstallationData?.update_details?.folder_structure_result ===
              null &&
            activeInstallationData?.update_details?.folder_structure_error ===
              null
              ? texts.waitMessage
              : ""
          }
          disabled={
            isCancelRequestLoading ||
            (activeInstallationData?.update_details?.folder_structure_result ===
              null &&
              activeInstallationData?.update_details?.folder_structure_error ===
                null)
          }
        />
      </div>
    </div>
  );
}
